import AppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import Typography from "@mui/material/Typography";
import WelcomeName from "../styled-ui-elements/WelcomeName";
import SignInSignOutButton from "./SignInSignOutButton";
import WhatsNewButton from "./WhatsNewButton";
const psnLogo:string = require('../../../../images/psnlogo.svg').default;
import { Badge, IconButton, Stack, Tooltip } from "@mui/material";
import { AssignmentTurnedIn } from "@mui/icons-material";
import { useNavigate } from "react-router-dom";
import { useGetPendingApprovalsCountQuery } from "../../../../services/ApprovalService";

const NavBar = () => {
    const navigate = useNavigate();

    // Poll every 60s for the signed-in user's pending-approval count. Uses the
    // count-only endpoint so the badge stays cheap (no per-approval ticket
    // hydration on the server).
    const { data } = useGetPendingApprovalsCountQuery(
        { scope: 'mine' },
        { pollingInterval: 60_000 }
    );
    const pendingCount = data?.count ?? 0;

    return (
        <div style={{ flexGrow: 1 }}>
            <AppBar position="fixed" sx={{zIndex:(theme)=>theme.zIndex.drawer + 1}}>
                <Toolbar>
                    <Stack direction='row' justifyContent='space-between' alignItems='center' width='100%' padding={1}>
                        <Stack direction='row' gap={2} alignItems='center'>
                            <Typography 
                                variant="h5" 
                                component="div" 
                                sx={{ 
                                    fontWeight: 700,
                                    fontSize: '1.75rem',
                                    color: '#1e293b',
                                    letterSpacing: '0.5px',
                                    fontFamily: '"Segoe UI", "Roboto", "Helvetica", "Arial", sans-serif'
                                }}
                            >
                                Trackly
                            </Typography>
                        </Stack>
                        <a href={'/'}><img src={psnLogo} alt='logo'/></a>
                        <Stack direction='row' gap={1} alignItems='center'>
                            <WhatsNewButton />
                            <Tooltip title="My approvals">
                                <IconButton
                                    size="small"
                                    onClick={() => navigate('/approvals')}
                                    aria-label={`My approvals (${pendingCount} pending)`}
                                >
                                    <Badge badgeContent={pendingCount} color="error" max={99}>
                                        <AssignmentTurnedIn sx={{ color: '#1e293b' }} />
                                    </Badge>
                                </IconButton>
                            </Tooltip>
                            <WelcomeName />
                            <SignInSignOutButton />
                        </Stack>
                    </Stack>
                </Toolbar>
            </AppBar>

        </div>
    );
};

export default NavBar;